<template>
  <v-container class="col-6 pa-3">
    <v-card>
      <v-card-text class="pt-0">
        <v-btn
          v-if="count > 1"
          style="position: absolute; top: 0; right: 0; z-index: 100"
          class="my-auto"
          icon
          @click="remove()"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-tabs touchless centered v-model="bonusTypeModel" class="bt-bonus-tab">
          <v-tab class="mt-tab-item" key="bonus" href="#mt-bonus">Bonus</v-tab>
          <v-tab class="mt-tab-item" key="sport_bonus" href="#mt-sport_bonus">Sport Bonus</v-tab>
          <v-tab class="mt-tab-item" key="freespins" href="#mt-freespins">Freespins</v-tab>
          <v-tab class="mt-tab-item" key="loyalty" href="#mt-loyalty">Loyalty</v-tab>

          <v-tab-item
            id="mt-bonus"
          >
            <v-form
              ref="mt-form-bonus"
              v-model="bonus.valid"
              class="mt-4"
            >

              <v-row justify="center" class="px-0 mx-0">
                <v-select
                  label="Rollover Type"
                  :rules="[v => !!v || 'Rollover Type is required']"
                  v-model="bonus.form.rollover_type"
                  :items="bonus.rollover_type">
                </v-select>

                <v-checkbox
                  label="Sticky bonus"
                  v-model="bonus.form.sticky"
                  hide-details
                  :true-value="1"
                  :false-value="0"
                  class="ml-3 mt-0 pt-5"
                />
              </v-row>

              <v-row justify="center">
                <v-text-field
                  required
                  label="Wager"
                  type="number"
                  class="col-3 pb-1"
                  :rules="[v => !!v || 'Wager is required']"
                  v-model="bonus.form.wager"
                />

                <v-text-field
                  required
                  label="Lifetime"
                  type="number"
                  class="col-3 pb-1"
                  :rules="[v => !!v || 'Lifetime is required']"
                  v-model="bonus.form.lifetime"
                />
                <v-select
                  label="Period"
                  :rules="[v => !!v || 'Period is required']"
                  v-model="bonus.form.lifetime_period"
                  :items="lifetimePeriods"
                  class="col-4 pb-1"
                />
              </v-row>
              <v-row v-if="type != 'cashback'">
                <v-text-field
                  required
                  label="Deposit Amount %"
                  type="number"
                  v-model="bonus.form.deposit_amount_percent"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Max Release"
                  type="number"
                  v-model="bonus.form.max_release"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Amount"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="bonus.form.amount"
                  :suffix="$store.state.manual_transaction.account.currency || ''"
                  hide-details
                  class="col-4"
                ></v-text-field>
              </v-row>

              <v-divider class="mb-3 mt-2" />

              <v-row justify="center" class="px-0 mx-0">
                <v-combobox
                  multiple
                  auto-select-first
                  label="Brands (filter)"
                  class="col-6 pl-0"
                  hide-details
                  @input="bonusClearBrandFilter"
                  :search-input.sync="bonus.brandsFilterInput"
                  v-model="bonus.brandsFilter"
                  :items="bonus.brands"
                />
                <v-autocomplete
                  :loading="gameLoading"
                  label="Exclusive for Game"
                  item-text="name"
                  item-value="game_id"
                  hide-details
                  class="col-6 pr-0"
                  clearable
                  v-model="bonus.form.game_id"
                  :prefix="'#' + (bonus.form.game_id || '')"
                  :items="filteredBonusGames"
                />
              </v-row>
              <v-row justify="center" class="px-0 mx-0">
                <v-autocomplete
                  label="Exclusive for Brand"
                  hide-details
                  clearable
                  class="col-6 pl-0"
                  v-model="bonus.form.brand_exclusive"
                  :items="providerBrandsAliases"
                />
                <v-autocomplete
                  label="Exclusive for System"
                  hide-details
                  clearable
                  class="col-6 pr-0"
                  v-model="bonus.form.system_exclusive"
                  :items="providerSystemsAliases"
                />
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            id="mt-sport_bonus"
          >
            <v-form
              ref="mt-form-sport_bonus"
              v-model="sport_bonus.valid"
              class="mt-4"
            >
              <v-row justify="center" class="px-0 mx-0">
                <v-select
                  label="Rollover Type"
                  :rules="[v => !!v || 'Rollover Type is required']"
                  v-model="sport_bonus.form.rollover_type"
                  :items="sport_bonus.rollover_type">
                </v-select>

                <v-checkbox
                  label="Sticky bonus"
                  v-model="sport_bonus.form.sticky"
                  hide-details
                  :true-value="1"
                  :false-value="0"
                  class="ml-3 mt-0 pt-5"
                />
              </v-row>

              <v-select
                label="Type"
                :rules="[v => !!v || 'Type is required']"
                v-model="sport_bonus.form.bonus_type"
                :items="sport_bonus.bonus_type">
              </v-select>

              <v-select
                label="Release Type"
                :rules="[v => !!v || 'Release Type is required']"
                v-model="sport_bonus.form.release_type"
                :items="sport_bonus.release_type">
              </v-select>

              <v-row justify="center">
                <v-text-field
                  required
                  label="Wager"
                  type="number"
                  class="col-3"
                  :rules="[v => !!v || 'Wager is required']"
                  v-model="sport_bonus.form.wager"
                ></v-text-field>

                <v-text-field
                  required
                  label="Lifetime"
                  type="number"
                  class="col-3 pb-1"
                  :rules="[v => !!v || 'Lifetime is required']"
                  v-model="sport_bonus.form.lifetime"
                ></v-text-field>
                <v-select
                  label="Period"
                  :rules="[v => !!v || 'Period is required']"
                  v-model="sport_bonus.form.lifetime_period"
                  :items="lifetimePeriods"
                  class="col-4 pb-1"
                ></v-select>
              </v-row>
              <v-row v-if="type != 'cashback'">
                <v-text-field
                  required
                  label="Deposit Amount %"
                  type="number"
                  v-model="sport_bonus.form.deposit_amount_percent"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Max Release"
                  type="number"
                  v-model="sport_bonus.form.max_release"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Amount"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="sport_bonus.form.amount"
                  :suffix="$store.state.manual_transaction.account.currency || ''"
                  hide-details
                  class="col-4"
                ></v-text-field>
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            id="mt-freespins"
          >
            <v-form
              ref="mt-form-freespins"
              v-model="freespins.valid"
              class="mt-4"
            >
              <v-row justify="center" class="px-0 mx-0">
                <v-select
                  label="Rollover Type"
                  :rules="[v => !!v || 'Rollover Type is required']"
                  v-model="freespins.form.rollover_type"
                  :items="bonus.rollover_type">
                </v-select>

                <v-checkbox
                  label="Sticky bonus"
                  v-model="freespins.form.sticky"
                  hide-details
                  :true-value="1"
                  :false-value="0"
                  class="ml-3 mt-0 pt-5"
                />
              </v-row>

              <v-combobox
                multiple
                label="Brands (filter)"
                auto-select-first
                :search-input.sync="freespins.brandsFilterInput"
                @input="freespinsClearBrandFilter"
                v-model="freespins.brandsFilter"
                :items="freespins.brands">
              </v-combobox>
              <v-autocomplete
                :loading="gameLoading"
                label="Game"
                item-text="name"
                item-value="game_id"
                clearable
                v-model="freespins.form.game_id"
                :prefix="'#' + (freespins.form.game_id || '')"
                :items="filteredFreespinsGames"
              >
                <template slot="item" slot-scope="{ item }">
                  <div style="width: 100%">
                    <span v-html="item.name"></span>
                    <small class="float-right">({{ item.system_name }})</small>
                  </div>
                </template>

              </v-autocomplete>

              <v-row justify="center">
                <v-text-field
                  required
                  label="Wager"
                  type="number"
                  class="col-3"
                  :rules="[v => !!v || 'Wager is required']"
                  v-model="freespins.form.wager"
                  hide-details
                ></v-text-field>

                <v-text-field
                  required
                  label="Lifetime"
                  type="number"
                  class="col-3 pb-1"
                  :rules="[v => !!v || 'Lifetime is required']"
                  v-model="bonus.form.lifetime"
                ></v-text-field>
                <v-select
                  label="Period"
                  :rules="[v => !!v || 'Period is required']"
                  v-model="bonus.form.lifetime_period"
                  :items="lifetimePeriods"
                  class="col-4 pb-1"
                ></v-select>
              </v-row>

              <v-row v-if="type != 'cashback'">
                <v-text-field
                  required
                  label="Max FS Win"
                  type="number"
                  v-model="freespins.form.max_freespin_win"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Max Release"
                  type="number"
                  v-model="freespins.form.max_release"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Amount"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="freespins.form.amount"
                  hide-details
                  class="col-4"
                ></v-text-field>
              </v-row>
              <v-divider class="mb-3 mt-2" />

              <v-label>Freespin win:</v-label>
              <v-row justify="center" class="px-0 mx-0">
                <v-autocomplete
                  class="col-6 pl-0"
                  label="Exclusive for Brand"
                  clearable
                  hide-details
                  v-model="freespins.form.brand_exclusive"
                  :items="providerBrandsAliases"
                />
                <v-autocomplete
                  class="col-6 pr-0"
                  label="Exclusive for System"
                  clearable
                  hide-details
                  v-model="freespins.form.system_exclusive"
                  :items="providerSystemsAliases"
                />
                <v-autocomplete
                  class="col-12 px-0"
                  :loading="gameLoading"
                  label="Exclusive for Game"
                  item-text="name"
                  item-value="game_id"
                  hide-details
                  clearable
                  v-model="freespins.form.game_id_exclusive"
                  :items="filteredBonusGames"
                />
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            id="mt-loyalty"
          >
            <v-form
              ref="mt-form-loyalty"
              v-model="loyalty.valid"
              class="mt-4"
            >
              <v-row class="mx-0">
                <v-text-field
                  required
                  label="Amount"
                  class="mx-auto col-6"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="loyalty.form.amount"
                  hide-details
                />
              </v-row>
            </v-form>
          </v-tab-item>
        </v-tabs>

      </v-card-text>
    </v-card>
  </v-container>
</template>

<style>
  .bt-bonus-tab .v-tabs-bar {
    zoom: 0.92;
  }
</style>

<script>

  import { uniq, filter, cloneDeep, map, get, round } from 'lodash'
  import { API } from '@/utils/api'
  import { mask } from 'vue-the-mask'

  export default {
    directives: {
      mask,
    },

    props: [ 'value', 'count', 'type' ],

    data: () => ({
      gameLoading: false,
      lifetimePeriods: [
        { text: 'Minutes', value: 'minutes' },
        { text: 'Hours', value: 'hours' },
        { text: 'Days', value: 'days' },
        { text: 'Weeks', value: 'weeks' },
        { text: 'Months', value: 'months' },
      ],
      bonus: {
        valid: null,
        message: 'Create bonus',
        initForm: {
          type: 'bonus',
          lifetime: 10,
          lifetime_period: 'days',
          rollover_type: 'bonus',
          wager: 30,
          deposit_amount_percent: 0,
          deposit_amount: 0,
        },
        form: {},
        rollover_type: [
          { text: 'Bonus', value: 'bonus' },
          { text: 'Cash', value: 'cash' }
        ],
        brands: [],
        brandsFilter: [],
        brandsFilterInput: '',
        games: [],
      },
      loyalty: {
        valid: null,
        message: 'Create loyalty',
        initForm: {
          amount: 0,
        },
        form: {}
      },
      sport_bonus: {
        valid: null,
        message: 'Create sport bonus',
        initForm: {
          type: 'sport_bonus',
          lifetime: 10,
          lifetime_period: 'days',
          rollover_type: 'bonus',
          release_type: 'bonus',
          bonus_type: 'STD',
          wager: 35,
          deposit_amount_percent: 0,
          deposit_amount: 0,
        },
        form: {},
        rollover_type: [
          { text: 'Bonus', value: 'bonus' },
          { text: 'Cash', value: 'cash' }
        ],
        bonus_type: [
          { text: 'Bonus money', value: 'STD' },
          { text: 'Free bet', value: 'FB' },
          { text: 'No Risk Bet', value: 'NRB' },
          { text: 'Free money bet', value: 'FMB' }
        ],
        release_type: [
          { text: 'Bonus', value: 'bonus' },
          { text: 'Cash', value: 'cash' }
        ],
      },

      freespins: {
        message: 'Create freespin bonus',
        valid: null,
        initForm: {
          type: 'freespins',
          lifetime: 10,
          lifetime_period: 'days',
          rollover_type: 'bonus',
          wager: 50,
        },
        form: {},
        brands: [],
        brandsFilter: [],
        brandsFilterInput: '',
        games: [],
      },
      state: null,
      bonusTypeModel: null,
      loading: false,
      transaction: {}
    }),

    mounted () {
      this.reset()
      console.log('init')
    },

    computed: {
      filteredBonusGames: function () {
        return this.bonus.games.filter(g => {
          return this.bonus.brandsFilter.length < 1 || (this.bonus.brandsFilter.includes(g.brand.alias))
        })
      },
      filteredFreespinsGames: function () {
        return this.freespins.games.filter(g => {
          return this.freespins.brandsFilter.length < 1 || (this.freespins.brandsFilter.includes(g.brand.alias))
        })
      },
      providerBrandsAliases: function () {
        return map(this.bonus.games, (i) => [ get(i, 'system_alias'), get(i, 'brand_alias') ].join('.'))
      },
      providerSystemsAliases: function () {
        return map(this.bonus.games, 'system_alias')
      }
    },

    watch: {

      value: function () {
      },

      bonusTypeModel: function () {
        if (this.value[0]) {
          this.value = this.value[0]
        }

        if (this.value.type) {
          this.bonusTypeModel = 'mt-' + this.value.type
        }

        let action = this.bonusTypeModel.replace('mt-', '')

        this[action].form = cloneDeep(this[action].initForm)

        if (this.value.type) {
          this[this.value.type].form = cloneDeep(this.value)
          this[this.value.type].form.type = this.value.type
        }

        // this.bonus.form = cloneDeep(this.bonus.initForm)
        // this.sport_bonus.form = cloneDeep(this.sport_bonus.initForm)
        // this.freespins.form = cloneDeep(this.freespins.initForm)

        this.$nextTick(function () {
          this.$emit('input', this[action].form)
        })
      },

      'bonus.form.deposit_amount_percent': function (val) {
        this.bonus.form.deposit_amount = round(((this.bonus.form.amount || 0) / this.bonus.form.deposit_amount_percent) * 100)
      },
      'bonus.form.amount': function (val) {
        this.bonus.form.deposit_amount = round(((this.bonus.form.amount || 0) / this.bonus.form.deposit_amount_percent) * 100)
      },
      'sport_bonus.form.deposit_amount_percent': function (val) {
        this.sport_bonus.form.deposit_amount = round(((this.sport_bonus.form.amount || 0) / this.sport_bonus.form.deposit_amount_percent) * 100)
      },
      'sport_bonus.form.amount': function (val) {
        this.sport_bonus.form.deposit_amount = round(((this.sport_bonus.form.amount || 0) / this.sport_bonus.form.deposit_amount_percent) * 100)
      },
    },

    methods: {
      remove: async function () {

        if (await this.$root.$confirm('Confirm', 'Are you sure you want to delete this bonus?')) {
          this.$emit('input', null)
          this.$destroy()
          this.$el.parentNode.removeChild(this.$el)
        }
      },
      bonusClearBrandFilter () {
        this.bonus.brandsFilterInput = ''
      },
      freespinsClearBrandFilter () {
        this.freespins.brandsFilterInput = ''
      },
      reset: function () {
        this.bonusTypeModel = 'bonus'

        this.gameLoading = true
        API.call('/$v/game/list.json', {}).then(resp => {
          this.bonus.games = resp.data
          this.bonus.brands = uniq(map(resp.data, 'brand.alias'))
          this.freespins.games = filter(resp.data, (g) => g.allow_freespins > 0)
          this.freespins.brands = uniq(map(this.freespins.games, 'brand.alias'))
        }).catch(e => {
        }).finally(() => {
          this.gameLoading = false
        })
      },
    }

  }
</script>
